/* eslint-disable */

import { useReducer } from "react";
import { useLoading, handleLoading } from "context/LoadingContext";
import { dialogInitState, dialogReducer } from "reducers/dialog";
import { useForm, useWatch } from "react-hook-form";
import cleanObject from "utils/cleanObject";
import handleEsriFilter from "utils/handleEsriFilter";
import { generateTextFromJson } from "utils/generateTextFromJson";
import addNewLog from "utils/addNewLog";
import { useAuth } from "context/auth";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function useFilter(props) {
  // based on reducerOrState you have to send the right params
  // state => then send setState
  // example of injectQueryUsingWatch ||
  // const injectQueryUsingWatch = useMemo(
  //   () => ({ names: ["STATUS"], operations: ["AND"], values: [1] }),
  //   []
  // );
  const {
    fields,
    featureLayer,
    domains,
    objName,
    reducerOrState,
    setState,
    view,
    dispatch,
    injectQuery,
    injectQueryUsingWatch,
    queryFeaturesOptions = {},
  } = props;
  const [dialogState, dispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );

  const [, dispatchLoading] = useLoading();
  const [auth, dispatchAuth] = useAuth();

  const toggleDialog = () => {
    dispatchDialog({ type: "TOGGLE" });
  };
  const methods = useForm();
  const { reset, control } = methods;
  const watch = useWatch({ name: injectQueryUsingWatch?.names, control });
  const onSubmitOfEsri = async (data) => {    
    const clearedData = cleanObject(data);
    await addNewLog({
      ipAddress: auth.ipAddress,
      hostname: auth.hostname,
      logDescription: `${generateTextFromJson(data,"بحث على قائمة الطلبات")}`});      

    handleLoading(dispatchLoading, true);

    try {
      // this lines is not tested
      let tempInjectQuery = injectQuery;
      if (injectQueryUsingWatch) {
        injectQueryUsingWatch.names.forEach((item, idx) => {
          const operation = injectQueryUsingWatch.operations[idx];
          const name = item;
          const value = injectQueryUsingWatch.operations.values[idx];
          const queryToInjectFromWatch = ` ${operation} ${name} = ${value}`;
          if (!watch[idx]) tempInjectQuery += queryToInjectFromWatch;
        });
      }
      // ----

      if (tempInjectQuery && Object.values(clearedData).length)
        tempInjectQuery = `AND ${tempInjectQuery}`;
      if (tempInjectQuery && !Object.values(clearedData).length)
        tempInjectQuery = ` ${tempInjectQuery}`;

      await handleEsriFilter({
        dispatch,
        data: clearedData,
        view,
        fields,
        featureLayer,
        domains,
        objName,
        reducerOrState,
        setState,
        injectQuery: tempInjectQuery,
        queryFeaturesOptions,
      });
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(dispatchLoading, false);
  };

  const handleResetFilter = () => {
    reset();
  };
  return {
    dialogState,
    toggleDialog,
    handleResetFilter,
    methods,
    onSubmitOfEsri,
    dispatchDialog,
  };
}

export default useFilter;
